import React, { Component } from 'react'
import FormComplainCustomer from '../../components/FormComplainCustomer/FormComplainCustomer'
import FormComplainLocation from '../../components/FormComplainLocation/FormComplainLocation'
import FormComplainDescription from '../../components/FormComplainDescription/FormComplainDescription'
import NoticeOfPrivacy from '../../components/NoticeOfPrivacy/NoticeOfPrivacy'
import Axios from 'axios';
import ReactDOM from 'react-dom'
import Modal from 'react-responsive-modal'
import './FormComplain.css'
import imgGuardando from '../../media/guardando.gif'
import imgGuardado from '../../media/guardado.gif'
import imgError from '../../media/error.gif'

class FormComplain extends Component {
  constructor() {
    super()
    this.state = {
      locations:[],
      stages:[],
      reasons:[],
      projects:[],
      complain:[],
      open: false
    }
    this.submit = this.submit.bind(this)
    this.onOpenModal = this.onOpenModal.bind(this)
    this.onCloseModal = this.onCloseModal.bind(this)
    this.reload = this.reload.bind(this)
  }

  componentWillMount() {
    Axios.get('/api/projects').then((res) => {
      this.setState({projects:res.data})
    })
    Axios.get('/api/stages').then((res) => {
      this.setState({stages:res.data})
    })
    Axios.get('/api/reasons').then((res) => {
      this.setState({reasons:res.data})
    })
  }

  submit(e){
    e.preventDefault();
    this.onOpenModal()
    let customerAnswer = document.getElementById("customer").checked? "Sí": "No"
    
    let complainData = {
      name: document.getElementById('name').value.trim(),
      lastNameP: document.getElementById('lastNameP').value.trim(),
      lastNameM: document.getElementById('lastNameM').value.trim(),
      email: document.getElementById('email').value.trim(),
      phoneNumber: document.getElementById('phoneNumber').value,
      type: document.getElementById('type').value,
      customer: customerAnswer,
      project: document.getElementById('project').value,
      reasonId: document.getElementById('reason').value,
      stageId: document.getElementById('stage').value,
      description: document.getElementById('description').value
    }
    if(customerAnswer==="Sí"){
      complainData.tower = document.getElementById('tower').value
      complainData.level = document.getElementById('level').value
      complainData.location = document.getElementById('location').value
    }
    console.log(complainData)
    this.setState({complain: complainData}, function () {
      Axios.post('/api/complain', this.state.complain).then(res => {
        this.updateModal()
      }).catch((e) =>{
        console.log(e)
        this.errorModal()
      })
    })
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };
 
  onCloseModal = () => {
    this.setState({ open: false });
  };

  updateModal = () => {
    ReactDOM.render('Su información ha sido guardada', document.getElementById('modalTittle'))
    let content = <div className="modalDiv">
                    <img src={imgGuardado} className="modalImg" alt="save"></img>
                    <p className="modalText">Le agradecemos su tiempo, marhnos se comunicará con usted en máximo 48 horas hábiles</p>
                    <br></br>
                    <button onClick={this.reload} className="btn btn-success modalBtnUnique">Cerrar</button>
                  </div>
    ReactDOM.render(content, document.getElementById('modalContent'))
  };

  errorModal = () => {
     ReactDOM.render('Su información ha sido guardada', document.getElementById('modalTittle'))
    let content = <div className="modalDiv">
                    <img src={imgGuardado} className="modalImg" alt="save"></img>
                    <p className="modalText">Le agradecemos su tiempo, marhnos se comunicará con usted en máximo 48 horas hábiles</p>
                    <br></br>
                    <button onClick={this.reload} className="btn btn-success modalBtnUnique">Cerrar</button>
                  </div>
    ReactDOM.render(content, document.getElementById('modalContent'))
    /*ReactDOM.render('Error', document.getElementById('modalTittle'))
    let content = <div className="modalDiv">
                    <img src={imgError} className="modalImg" alt="Error"></img>
                    <p className="modalText">Por favor inténtelo más tarde</p>
                    <br></br>
                    <button onClick={this.reload} className="btn btn-danger modalBtnUnique">Cerrar</button>
                  </div>
    ReactDOM.render(content, document.getElementById('modalContent'))*/
  };

  reload = () => {
    window.location.reload()
  }

  render() {
    return (
      <div className="formComplain">
        <form onSubmit={this.submit} className="Form container">
          <header className="Form-header">
            <h3 className="Form-title">Ingresa tu Queja o Sugerencia</h3>
          </header>
          <FormComplainCustomer />
          <FormComplainLocation projects={this.state.projects}/>
          <FormComplainDescription stages={this.state.stages} reasons={this.state.reasons}/>
          <NoticeOfPrivacy />
          <button type="submit" className="btn btn-danger btnComplain">Enviar información</button>
        </form>
        <Modal open={this.state.open} showCloseIcon={false} closeOnEsc={false} closeOnOverlayClick={false} center>
          <h2 id="modalTittle" className="modalTittle">En proceso...</h2>
          <div id="modalContent">
            <img src={imgGuardando} className="modalImg" alt="save"></img>
            <br></br>
            <p className="modalText">Por favor esperé mientras guardamos su información</p>
          </div>
        </Modal>
      </div>
    )  
  }
}

export default FormComplain



// WEBPACK FOOTER //
// ./src/views/FormComplain/FormComplain.js